module.exports = __webpack_public_path__ + "strapi-wordmark-3eadb382858477cc5fa9eea666a6704f.webp";